import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/site/HomePage";
import ProductsPage from "@/pages/site/ProductsPage";
import ProductPage from "@/pages/site/ProductPage";
import HowItWorksPage from "@/pages/site/HowItWorksPage";
import { NotFoundPage, PolicyPage, StoryPage } from "@/pages/site/OtherPages";
import CartPage from "@/pages/site/CartPage";
import CheckoutPage from "@/pages/site/CheckoutPage";
import PaymentResultPage from "@/pages/site/PaymentResultPage";
import CustomizerPage, { LegacyCustomizerRedirect } from "@/pages/site/CustomizerPage";
import DesignsAdmin from "@/pages/DesignsAdmin";
import InspirationAdmin from "@/pages/InspirationAdmin";
import SiteMediaAdmin from "@/pages/SiteMediaAdmin";
import OrdersAdmin from "@/pages/OrdersAdmin";
import InspirationPage from "@/pages/site/InspirationPage";
import Login from "@/pages/Login";
import Studio from "@/pages/Studio";
import CatalogAdmin from "@/pages/CatalogAdmin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center eyebrow">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/productos" element={<ProductsPage />} />
            <Route path="/productos/:slug" element={<ProductPage />} />
            <Route path="/personalizar" element={<CustomizerPage />} />
            <Route path="/personalizar/:slug" element={<LegacyCustomizerRedirect />} />
            <Route path="/como-funciona" element={<HowItWorksPage />} />
            <Route path="/nuestra-historia" element={<StoryPage />} />
            <Route path="/inspiracion/:slug" element={<InspirationPage />} />
            <Route path="/politicas/:slug" element={<PolicyPage />} />
            <Route path="/carrito" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/pedido/resultado" element={<PaymentResultPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/studio/catalogo" element={<Protected><CatalogAdmin /></Protected>} />
          <Route path="/studio/disenos" element={<Protected><DesignsAdmin /></Protected>} />
          <Route path="/studio/inspiracion" element={<Protected><InspirationAdmin /></Protected>} />
          <Route path="/studio/fotos" element={<Protected><SiteMediaAdmin /></Protected>} />
          <Route path="/studio/pedidos" element={<Protected><OrdersAdmin /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}
